import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from '../pages/LoginPage';
import VerifyEmailScreen from '../components/VerifyEmailScreen';

const Router = ({ children }) => {
  const { currentUser } = useAuth();

  // If no user is logged in, show LoginPage
  if (!currentUser) {
    return <LoginPage />;
  }

  // Check email verification:
  // Google sign-in accounts have emailVerified = true automatically.
  // Bypass only for admin@batcheet.com for dev/admin convenience.
  const isGoogleUser = currentUser.providerData?.some(p => p.providerId === 'google.com');
  const isAdmin = currentUser.email?.toLowerCase() === 'admin@batcheet.com';

  if (!currentUser.emailVerified && !isGoogleUser && !isAdmin) {
    return <VerifyEmailScreen />;
  }

  return children;
};

export default Router;

